import { render, staticRenderFns } from "./RightsFundWrongReplace.vue?vue&type=template&id=b1fdcb98"
import script from "./RightsFundWrongReplace.vue?vue&type=script&lang=js"
export * from "./RightsFundWrongReplace.vue?vue&type=script&lang=js"
import style0 from "./RightsFundWrongReplace.vue?vue&type=style&index=0&id=b1fdcb98&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports